module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-leadership-box-2-image-1858952c2f60f4959ad63ca2ff19ef06.png";